import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Tooltip,
  Typography,
} from "@mui/material";
import { DialogHeader } from "../../../../auth/components/DialogHeader";
import SelectInuputComponent, {
  SelectInputOptions,
} from "../../../../main/components/SelectInputComponent";
import {
  DatePicker,
  DateView,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { formatDate } from "../../../../main/utils/utils";

export enum CardFilterOptionsEnum {
  Dia = 1,
  Mes,
  Ano,
  Hora = 8,
  Live = 9,
}

export default function FilterCardModal(props: {
  open: boolean;
  setOpen: (open: boolean) => void;
  title: string;
  onConfirm?: () => void;
  possibleDateFilters: SelectInputOptions[];
  dateFilterType: CardFilterOptionsEnum | null;
  setDateFilterType: (filterType: CardFilterOptionsEnum) => void;
  hour?: number | undefined;
  setHour?: (hour: number) => void;
  date: Date | null;
  setDate: (date: Date | null) => void;
}) {
  const {
    open,
    title,
    setOpen,
    onConfirm,
    possibleDateFilters,
    hour,
    setHour,
    dateFilterType,
    setDateFilterType,
    date,
    setDate,
  } = props;

  const onClose = () => {
    setOpen(false);
  };

  const timeNow = new Date().getHours();

  const maxHour = timeNow <= 19 && timeNow > 6 ? timeNow - 1 : 19;

  const hourOptions = [
    {
      label: "06",
      value: 6,
    },
    {
      label: "07",
      value: 7,
    },
    {
      label: "08",
      value: 8,
    },

    {
      label: "09",
      value: 9,
    },
    {
      label: "10",
      value: 10,
    },
    {
      label: "11",
      value: 11,
    },
    {
      label: "12",
      value: 12,
    },
    {
      label: "13",
      value: 13,
    },
    {
      label: "14",
      value: 14,
    },
    {
      label: "15",
      value: 15,
    },
    {
      label: "16",
      value: 16,
    },
    {
      label: "17",
      value: 17,
    },
    {
      label: "18",
      value: 18,
    },
    {
      label: "19",
      value: 19,
    },
  ];

  const filteredHourOptions = hourOptions.filter(
    (item) => item.value <= maxHour
  );

  const hasFormat =
    dateFilterType === CardFilterOptionsEnum.Dia ||
    dateFilterType === CardFilterOptionsEnum.Hora ||
    dateFilterType === null;

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogHeader id="customized-dialog-title" onClose={onClose}>
        <Typography sx={{ marginRight: "40px", fontSize: "20px" }}>
          {title}
        </Typography>
      </DialogHeader>
      <DialogContent sx={{ marginY: "8px", width: "280px" }} dividers>
        <SelectInuputComponent
          options={possibleDateFilters}
          setFilter={setDateFilterType}
          title="Filtro"
          defaultValue={dateFilterType ? Number(dateFilterType) : undefined}
        />
        {dateFilterType !== CardFilterOptionsEnum.Live && (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Tooltip
              title={
                dateFilterType === null ? "Selecione um tipo de filtro!" : ""
              }
            >
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <DatePicker
                  format={hasFormat ? "DD/MM/YYYY" : undefined}
                  sx={{ marginY: "12px" }}
                  maxDate={dayjs(new Date())}
                  label="Data"
                  disabled={dateFilterType === null}
                  views={getDatePickerLabel(
                    dateFilterType ?? CardFilterOptionsEnum.Hora
                  )}
                  defaultValue={dayjs(date)}
                  onChange={(newValue: any) => setDate(newValue.$d)}
                />
                {dateFilterType === CardFilterOptionsEnum.Hora && setHour && (
                  <SelectInuputComponent
                    title="Hora"
                    options={
                      formatDate(date ?? new Date()) === formatDate(new Date())
                        ? filteredHourOptions
                        : hourOptions
                    }
                    setFilter={setHour}
                    defaultValue={hour}
                  />
                )}
              </Box>
            </Tooltip>
          </LocalizationProvider>
        )}
      </DialogContent>

      <DialogActions>
        <Button color="secondary" onClick={onClose}>
          {"Cancelar"}
        </Button>
        <Button
          variant="contained"
          disabled={dateFilterType === null}
          color={"primary"}
          onClick={onConfirm}
        >
          {"OK"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const getDatePickerLabel = (filterType: CardFilterOptionsEnum): DateView[] => {
  switch (filterType) {
    case CardFilterOptionsEnum.Mes:
      return ["month", "year"];
    case CardFilterOptionsEnum.Ano:
      return ["year"];
    default:
      return ["month", "year", "day"];
  }
};
